import { Alchemy, Network } from "alchemy-sdk";

export const ALCHEMY_CONFIG_DICT = {
  MUMBAI: {
    apiKey: "bvAky-x4vTwASR8qOwh_a42_DnI7dVj-",
    network: Network.MATIC_MUMBAI,
  },
  ETHEREUM_TESTNET: {
    apiKey: "1XhXKXcfprffTmOYWF0VOPgDmKMCib5j",
    network: Network.ETH_SEPOLIA,
  },
  POLYGON: {
    api: "FDpwrw59-ZzvmXTDArDbZRVBU9fZUwcJ",
    network: Network.MATIC_MAINNET,
  },
  BASE_SEPOLIA: {
    api: "dxPQSa8iVaWmaKbh-ofdw4PrRspzxMmv",
    network: Network.BASE_SEPOLIA,
  },
  BASE: {
    api: "opYbWGVCNugTESzT3fMYisjaQcmFKxvY",
    network: Network.BASE,
  },
};

export const ALCHEMY_APIS_DICT = {
  ETHEREUM: {
    TESTNET: new Alchemy(ALCHEMY_CONFIG_DICT.ETHEREUM_TESTNET),
    MAINNET: null,
  },
  POLYGON: {
    TESTNET: new Alchemy(ALCHEMY_CONFIG_DICT.MUMBAI),
    MAINNET: new Alchemy(ALCHEMY_CONFIG_DICT.POLYGON),
  },
  BASE: {
    TESTNET: new Alchemy(ALCHEMY_CONFIG_DICT.BASE_SEPOLIA),
    MAINNET: new Alchemy(ALCHEMY_CONFIG_DICT.BASE),
  },
};

export const UNIBLOCK_CHAIN_IDS_DICT = {
  ETHEREUM: {
    MAINNET: 1,
    TESTNET: 11155111,
  },
  BSC: {
    MAINNET: 56,
    TESTNET: 97,
  },
  POLYGON: {
    MAINNET: 137,
    TESTNET: 80001,
  },
  BASE: {
    MAINNET: 8453,
    TESTNET: 84532,
  },
};

export const UNIBLOCK_OPTIONS = {
  method: "GET",
  headers: {
    accept: "application/json",
    "X-API-KEY": process.env.REACT_APP_UNIBLOCK_API_KEY,
  },
};
